import { Box, makeStyles, Tooltip } from '@material-ui/core';
import React, { FC, ReactNode } from 'react';
import { IconInfo } from '..';
import { useShopConfigV2 } from '../../hooks/shopConfig';

interface BundlePanelInfoTooltipProps {
  title: NonNullable<ReactNode>;
}

interface StyledTooltipProps {
  backgroundColor?: string;
  color?: string;
}

// Inject styles into the MUI tooltip to change the tooltip background and foreground colors
const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTooltip-tooltip': {
      backgroundColor: (props: StyledTooltipProps) =>
        props.backgroundColor || theme.palette.common.white,
      boxShadow: theme.shadows[3],
      color: (props: StyledTooltipProps) => props.color || theme.palette.common.black,
    },
  },
}));

const BundlePanelInfoTooltip: FC<BundlePanelInfoTooltipProps> = ({ title }) => {
  // Inject brand colors into the tooltip popper
  const { css: brandCss } = useShopConfigV2();
  const classes = useStyles({
    backgroundColor: brandCss?.backgroundColor,
    color: brandCss?.body2?.color,
  });

  return (
    <Tooltip classes={{ popper: classes.root }} title={title} placement="right" enterTouchDelay={0}>
      <Box>
        <IconInfo height="1em" width="1em" />
      </Box>
    </Tooltip>
  );
};

export default BundlePanelInfoTooltip;
